// extracted by mini-css-extract-plugin
module.exports = {"space":"ResendModal_space__3SE-T","err-msg":"ResendModal_err-msg__2-llI","email-input":"ResendModal_email-input__gaUY0"};